export default function toFixed(num, precision) {
	let fixedVal = (+(
		Math.round(+(num + "e" + precision)) +
		"e" +
		-precision
	)).toFixed(precision);
	fixedVal = !isNaN(fixedVal) ? fixedVal : null;

	return fixedVal;
}
